// Cache Buster: v2026-02-16-1100
// Updated error handling for Cart API debugging

class TabbedContent extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
      const title = this.querySelector('.tabbed-content_title');
      if (title) {
        title.addEventListener('click', () => {
          title.classList.toggle('open');
        });
      }
    }
}

customElements.define('tabbed-content', TabbedContent);

// ========================================
// TEIL 0: SessionStorage für Dimensionen
// ========================================
function saveDimensionsToSession() {
  const activeTab = document.querySelector('.tab-btn.active');
  const isCustomTab = activeTab && activeTab.textContent.includes('Zuschnitt nach Maß');
  
  if (!isCustomTab) {
    return;
  }
  
  const widthInput = document.querySelector('#width-input');
  const lengthInput = document.querySelector('#length-input');
  
  if (widthInput && lengthInput) {
    const width = widthInput.value;
    const length = lengthInput.value;
    
    if (width && length) {
      sessionStorage.setItem('custom_width', width);
      sessionStorage.setItem('custom_length', length);
    }
  }
}

function loadDimensionsFromSession() {
  const savedWidth = sessionStorage.getItem('custom_width');
  const savedLength = sessionStorage.getItem('custom_length');
  
  if (savedWidth && savedLength) {
    const widthInput = document.querySelector('#width-input');
    const lengthInput = document.querySelector('#length-input');
    
    if (widthInput && lengthInput) {
      widthInput.value = savedWidth;
      lengthInput.value = savedLength;
      
      // Trigger price calculation
      if (window.priceCalculator && typeof window.priceCalculator.calculate === 'function') {
        setTimeout(() => {
          window.priceCalculator.calculate();
        }, 300);
      }
    }
  }
}

function clearDimensionsFromSession() {
  sessionStorage.removeItem('custom_width');
  sessionStorage.removeItem('custom_length');
}

// ========================================
// TEIL 1: Direkte Produktverlinkung via data-href
// ========================================
document.addEventListener('DOMContentLoaded', () => {
  // Event-Delegation für Pills mit data-href
  document.addEventListener('click', (e) => {
    const target = e.target;
    
    // Prüfe ob es ein Label mit data-href ist
    if (target.tagName === 'LABEL' && target.hasAttribute('data-href') && !target.classList.contains('disabled')) {
      // Save dimensions before navigation
      saveDimensionsToSession();
      
      const url = target.getAttribute('data-href');
      if (url) {
        window.location.href = url;
      }
    }
  });
  
  // Event-Handler für Dropdowns mit data-href
  document.addEventListener('change', (e) => {
    const target = e.target;
    
    if (target.tagName === 'SELECT' && target.classList.contains('select__select')) {
      const selectedOption = target.options[target.selectedIndex];
      if (selectedOption && selectedOption.hasAttribute('data-href')) {
        // Save dimensions before navigation
        saveDimensionsToSession();
        
        const url = selectedOption.getAttribute('data-href');
        if (url) {
          window.location.href = url;
        }
      }
    }
  });
  
  // Load dimensions from sessionStorage on page load
  loadDimensionsFromSession();
});

// ========================================
// TEIL 2: Modal für ausgegraute Optionen
// ========================================
document.addEventListener('DOMContentLoaded', () => {
  // Event-Delegation für ausgegraute Pills/Options
  document.addEventListener('click', (e) => {
    const target = e.target;
    
    // Prüfe ob es ein disabled Label oder Option ist
    if (
      (target.tagName === 'LABEL' && target.hasAttribute('data-modal-trigger')) ||
      (target.tagName === 'OPTION' && target.hasAttribute('data-modal-trigger'))
    ) {
      e.preventDefault();
      e.stopPropagation();
      
      const propertyValue = target.getAttribute('data-property-value');
      const propertyName = target.getAttribute('data-property-name');
      const propertyIndex = target.getAttribute('data-property-index');
      
      openPropertyAlternativesModal(propertyValue, propertyName, propertyIndex);
    }
  });
});

function openPropertyAlternativesModal(propertyValue, propertyName, propertyIndex) {
  // Parse JSON-Daten
  const dataElement = document.getElementById('property-alternatives-data');
  if (!dataElement) {
    console.error('property-alternatives-data nicht gefunden');
    return;
  }
  
  let data;
  try {
    data = JSON.parse(dataElement.textContent);
  } catch (err) {
    console.error('Fehler beim Parsen der JSON-Daten:', err);
    return;
  }
  
  // Filtere Metaobjekte nach propertyValue
  const filteredMetaobjects = data.metaobjects.filter(mo => {
    return mo.properties[propertyName] === propertyValue && mo.products.length > 0;
  });
  
  if (filteredMetaobjects.length === 0) {
    alert('Keine alternativen Produkte verfügbar.');
    return;
  }
  
  // Erstelle Modal-HTML
  const modalHTML = createModalHTML(filteredMetaobjects, data.properties, data.propertyTitles, propertyValue, propertyName);
  
  // Injiziere vor main#MainContent
  const mainContent = document.querySelector('main#MainContent');
  if (mainContent) {
    mainContent.insertAdjacentHTML('beforebegin', modalHTML);
  } else {
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }
  
  // Event-Listener für Schließen
  const modal = document.querySelector('.property-alternatives-modal-overlay');
  if (modal) {
    // Schließen-Button
    const closeBtn = modal.querySelector('.property-alternatives-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeModal(modal));
    }
    
    // Overlay-Click (aber nicht auf Content)
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal(modal);
      }
    });
    
    // ESC-Taste
    const escHandler = (e) => {
      if (e.key === 'Escape') {
        closeModal(modal);
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
    
    // Speichere Handler für späteres Cleanup
    modal._escHandler = escHandler;
  }
}

function createModalHTML(metaobjects, properties, propertyTitles, selectedValue, selectedProperty) {
  // Sammle alle Produkte mit ihren Properties
  const products = [];
  metaobjects.forEach(mo => {
    mo.products.forEach(prod => {
      products.push({
        ...prod,
        properties: mo.properties
      });
    });
  });
  
  // Sortiere Produkte nach Properties (property_1, property_2, ...)
  products.sort((a, b) => {
    // Durchlaufe alle Properties in der Reihenfolge
    for (let i = 0; i < properties.length; i++) {
      const prop = properties[i];
      const valA = a.properties[prop] || '';
      const valB = b.properties[prop] || '';
      
      // Vergleiche als Strings (alphabetisch)
      if (valA < valB) return -1;
      if (valA > valB) return 1;
      // Wenn gleich, prüfe nächste Property
    }
    return 0; // Alle Properties sind gleich
  });
  
  // Hole Property-Titel für die Überschrift
  const propertyTitle = propertyTitles[selectedProperty] || selectedProperty;
  
  // Erstelle Tabellen-HTML
  let tableHTML = `
    <div class="property-alternatives-modal-overlay">
      <div class="property-alternatives-modal-content">
        <button class="property-alternatives-modal-close" aria-label="Schließen">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <h3 class="property-alternatives-modal-title">Alternative Produkte für ${propertyTitle}: ${selectedValue}</h3>
        <p class="property-alternatives-modal-description">Für Ihre bisherige Auswahl gibt es leider keine Eigenschaft "${propertyTitle}" mit dem Wert "${selectedValue}". Hier finden Sie alternative Produkte.</p>
        <div class="property-alternatives-modal-table-wrapper">
          <table class="property-alternatives-modal-table">
            <thead>
              <tr>
  `;
  
  // Spaltenüberschriften für alle Properties - verwende Titel statt property keys
  properties.forEach(prop => {
    const title = propertyTitles[prop] || prop;
    tableHTML += `<th>${title}</th>`;
  });
  tableHTML += `<th>Aktion</th>`;
  tableHTML += `</tr></thead><tbody>`;
  
  // Zeilen für jedes Produkt
  products.forEach(prod => {
    tableHTML += `<tr>`;
    properties.forEach(prop => {
      const value = prod.properties[prop] || '-';
      tableHTML += `<td>${value}</td>`;
    });
    tableHTML += `<td><a href="${prod.url}" class="property-alternatives-modal-link" onclick="saveDimensionsToSession(); return true;">Produkt auswählen</a></td>`;
    tableHTML += `</tr>`;
  });
  
  tableHTML += `
          </tbody>
        </table>
      </div>
    </div>
  </div>
  `;
  
  return tableHTML;
}

function closeModal(modal) {
  // Entferne ESC-Handler
  if (modal._escHandler) {
    document.removeEventListener('keydown', modal._escHandler);
  }
  
  // Entferne Modal
  modal.remove();
}

// ========================================
// TEIL 3: Preisberechnung für Blechzuschnitte
// ========================================
(function() {
  'use strict';
  
  // Wait for config to be available
  if (typeof window.priceConfigs === 'undefined') {
    console.warn('Price calculator config not found');
    return;
  }
  
  const config = window.priceConfigs;

  // Price cache – updated after every successful /getprice response
  window.priceCache = {
    price: null,
    totalPrice: null,
    old_price: null
  };
  
  // DOM elements (initialized on DOMContentLoaded)
  let priceContainer, quantityInput, savingsDisplay, savingsAmount;
  let oldPriceEl, priceItemEl, loadingState, errorMessage;
  let weightDisplay, weightValue;
  let currentWeight = 0;
  
  // Format price helper
  function formatPrice(price) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  }
  
  // Show error message
  function showError(message) {
    if (errorMessage) {
      errorMessage.textContent = message;
      errorMessage.style.display = 'block';
    }
  }
  
  // Show error message and disable cart button
  function showErrorAndDisableCart(message) {
    if (errorMessage) {
      errorMessage.innerHTML = message;
      errorMessage.style.display = 'block';
    }
    disableCart();
  }
  
  // Hide error message
  function hideError() {
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
  }
  
  // Disable cart button
  function disableCart() {
    const cartButton = document.querySelector('.btn-cart');
    if (cartButton) {
      cartButton.disabled = true;
      cartButton.style.opacity = '0.5';
      cartButton.style.cursor = 'not-allowed';
    }
  }
  
  // Enable cart button
  function enableCart() {
    const cartButton = document.querySelector('.btn-cart');
    if (cartButton) {
      cartButton.disabled = false;
      cartButton.style.opacity = '1';
      cartButton.style.cursor = 'pointer';
    }
  }
  
  // Extract dimensions from standard format
  function extractDimensions(formatString) {
    // Remove text in parentheses (e.g., " (Ganze Tafel)"), then " mm", and split by " x "
    const cleaned = formatString
      .replace(/\s*\([^)]*\)\s*$/, '') // Remove " (any text)" at the end
      .replace(' mm', ''); // Remove " mm"
    const parts = cleaned.split(' x ');
    return {
      width: parseInt(parts[0].replace(/\./g, '')), // Remove dots from number (e.g., 2.000 -> 2000)
      height: parseInt(parts[1].replace(/\./g, '')) // Remove dots from number (e.g., 2.000 -> 2000)
    };
  }
  
  // Get current parameters for price calculation
  function getCalculationParams() {
    const activeTab = document.querySelector('.tab-btn.active');
    const isCustomTab = activeTab && activeTab.textContent.includes('Zuschnitt nach Maß');
    
    let width, length, staerke;
    
    if (isCustomTab) {
      // Get from input fields
      const widthInput = document.querySelector('input[name="width"]');
      const heightInput = document.querySelector('input[name="length"]');
      const staerkeSelect = document.querySelector('select[name="thickness"]');
      width = widthInput ? parseInt(widthInput.value) : 0;
      length = heightInput ? parseInt(heightInput.value) : 0;
      staerke = staerkeSelect ? parseFloat(staerkeSelect.value) : 0;
    } else {
      // Get from select dropdown
      const standardSelect = document.querySelector('#standard select');
      const staerkeSelect = document.querySelector('select[name="thickness"]');
      if (standardSelect) {
        const selectedOption = standardSelect.options[standardSelect.selectedIndex];
        if (selectedOption) {
          width = parseInt(selectedOption.getAttribute('data-width')) || 0;
          length = parseInt(selectedOption.getAttribute('data-length')) || 0;
        }
      }
      staerke = staerkeSelect ? parseFloat(staerkeSelect.value) : 0;
    }
    
    // Get toggle values - only for custom tab (Zuschnitt nach Maß)
    let entgratung = 0;
    let express = 0;
    
    if (isCustomTab) {
      // Only read toggles from the custom tab
      const customTabElement = document.querySelector('#custom');
      if (customTabElement) {
        const customCheckboxes = customTabElement.querySelectorAll('input[type="checkbox"]');
        customCheckboxes.forEach(checkbox => {
          const parentText = checkbox.parentElement.parentElement.textContent.toLowerCase();
          if (parentText.includes('entgrat')) {
            entgratung = checkbox.checked ? 1 : 0;
          } else if (parentText.includes('express')) {
            express = checkbox.checked ? 1 : 0;
          }
        });
      }
    }
    // For standard formats, entgratung and express remain 0
    
    // Get randauswahl value if present
    let randauswahl = '';
    const randauswahlSelect = document.querySelector('select[name="randauswahl"]');
    if (randauswahlSelect && randauswahlSelect.value) {
      randauswahl = randauswahlSelect.value;
    }
    
    // Get current weight if available
    let weight = 0;
    if (window.priceCalculator && typeof window.priceCalculator.getCurrentWeight === 'function') {
      weight = window.priceCalculator.getCurrentWeight();
    }
    
    return {
      produktart: config.produktart || '',
      blechart: config.blechart || '',
      matID: config.materialId || 0,
      parentSku: config.productSku || '',
      parentProductId: config.productId || 0,
      entgratung: entgratung,
      express: express,
      width: width || 0,
      length: length || 0,
      staerke: staerke || 0,
      amount: quantityInput ? parseInt(quantityInput.value) || 1 : 1,
      type: isCustomTab ? 'custom' : 'std',
      randauswahl: randauswahl,
      weight: weight
    };
  }
  
  // Validate parameters before sending
  function validateParams(params) {
    const errors = [];
    
    if (!params.produktart) errors.push('Produktart fehlt');
    if (!params.blechart) errors.push('Blechart fehlt');
    if (!params.matID || params.matID === 0) errors.push('Material-ID fehlt');
    if (params.width <= 0) errors.push('Breite muss größer als 0 sein');
    if (params.length <= 0) errors.push('Länge muss größer als 0 sein');
    if (params.amount <= 0) errors.push('Menge muss größer als 0 sein');
    
    return errors;
  }
  
  // Calculate price via API
  async function calculatePrice() {
    const endpoint = config.endpointGetPrice;
    
    if (!endpoint) {
      console.warn('Kein Endpunkt für Preisberechnung konfiguriert');
      showErrorAndDisableCart('Preiskonfigurationen sind aktuell leider nicht möglich. Wenden Sie sich an unser Service-Team unter <a href="mailto:support@cutico.de" style="color: white; text-decoration: underline;">support@cutico.de</a>.');
      return;
    }
    
    // Validate dimensions first
    if (!validateDimensions()) {
      return; // Stop if dimensions are invalid
    }
    
    hideError();
    enableCart();

    // Invalidate cache before fetching fresh data
    window.priceCache = { price: null, totalPrice: null, old_price: null };
    
    // Show loading state
    if (loadingState) loadingState.style.display = 'block';
    
    const params = getCalculationParams();
    
    // Validate parameters
    const validationErrors = validateParams(params);
    if (validationErrors.length > 0) {
      if (loadingState) loadingState.style.display = 'none';
      showError('Validierung fehlgeschlagen: ' + validationErrors.join(', '));
      return;
    }
    
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      });
      
      if (!response.ok) {
        throw new Error('Netzwerkfehler: ' + response.status);
      }
      
      const result = await response.json();
      
      if (loadingState) loadingState.style.display = 'none';
      
      if (!result.success) {
        showError(result.message || 'Fehler bei der Preisberechnung');
        return;
      }
      
      // Update price cache
      if (result.data) {
        window.priceCache = {
          price:      result.data.price      ?? null,
          totalPrice: result.data.totalPrice ?? null,
          old_price:  result.data.old_price  ?? null
        };
      }

      // Update price display
      if (result.data && priceItemEl) {
        priceItemEl.textContent = formatPrice(result.data.totalPrice);
        
        // Store weight for cart
        if (result.data.totalWeight) {
          currentWeight = result.data.totalWeight;
          if (weightValue) {
            // Format weight with German locale (comma as decimal separator, max 2 decimals)
            weightValue.textContent = new Intl.NumberFormat('de-DE', {
              minimumFractionDigits: 1,
              maximumFractionDigits: 2
            }).format(result.data.totalWeight);
            weightDisplay.style.display = 'block';
          }
        }
        
        // Show discount if applicable
        if (result.data.discount && result.data.old_price) {
          savingsAmount.textContent = formatPrice(result.data.discount);
          oldPriceEl.textContent = formatPrice(result.data.old_price);
          savingsDisplay.style.display = 'block';
          oldPriceEl.style.display = 'block';
        } else {
          savingsDisplay.style.display = 'none';
          oldPriceEl.style.display = 'none';
        }
      }
      
    } catch (error) {
      if (loadingState) loadingState.style.display = 'none';
      showErrorAndDisableCart('Preiskonfigurationen sind aktuell leider nicht möglich. Wenden Sie sich an unser Service-Team unter <a href="mailto:support@cutico.de" style="color: white; text-decoration: underline;">support@cutico.de</a>.');
      console.error('Price calculation error:', error);
    }
  }
  
  // Setup event listeners
  function setupEventListeners() {
    // Quantity change
    if (quantityInput) {
      quantityInput.addEventListener('input', calculatePrice);
    }
    
    // Width and height inputs (custom tab)
    const widthInput = document.querySelector('input[name="width"]');
    const heightInput = document.querySelector('input[name="length"]');
    if (widthInput) widthInput.addEventListener('input', calculatePrice);
    if (heightInput) heightInput.addEventListener('input', calculatePrice);
    
    // All checkboxes (entgratung, express, etc.)
    const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');
    allCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', calculatePrice);
    });
    
    // Standard format select
    const standardSelect = document.querySelector('#standard select');
    if (standardSelect) {
      standardSelect.addEventListener('change', calculatePrice);
    }
    
    // Tab switching
    const tabButtons = document.querySelectorAll('.tab-btn');
    tabButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        // Delay to allow tab switch to complete
        setTimeout(calculatePrice, 100);
      });
    });
  }
  
  // Initialize on DOM ready
  // Validate custom dimensions
  function validateDimensions() {
    const widthInput = document.getElementById('width-input');
    const lengthInput = document.getElementById('length-input');
    
    if (!widthInput || !lengthInput) {
      return true; // If inputs don't exist, no validation needed
    }
    
    const width = parseFloat(widthInput.value);
    const length = parseFloat(lengthInput.value);
    const errors = [];
    
    if (isNaN(width) || width < 100 || width > 1000) {
      errors.push('Breite muss zwischen 100 mm und 1000 mm liegen.');
    }
    
    if (isNaN(length) || length < 100 || length > 2000) {
      errors.push('Länge muss zwischen 100 mm und 2000 mm liegen.');
    }
    
    if (errors.length > 0) {
      showErrorAndDisableCart(errors.join('<br>'));
      return false;
    }
    
    hideError();
    enableCart();
    return true;
  }
  
  // Make validateDimensions globally accessible
  window.validateDimensions = validateDimensions;

  function initPriceCalculator() {
    // Get DOM elements
    priceContainer = document.querySelector('.price-container');
    quantityInput = document.getElementById('quantity-' + config.sectionId);
    savingsDisplay = document.querySelector('.savings-display');
    savingsAmount = document.querySelector('.savings-amount');
    oldPriceEl = document.querySelector('.old-price');
    priceItemEl = document.querySelector('.actual-price .price-item');
    loadingState = document.querySelector('.loading-state');
    errorMessage = document.getElementById('price-error-message');
    weightDisplay = document.querySelector('.weight-display');
    weightValue = document.querySelector('.weight-value');
    
    if (!priceContainer) {
      console.warn('Price container not found');
      return;
    }
    
    // Setup event listeners
    setupEventListeners();
    
    // Add dimension validation listeners
    const widthInput = document.getElementById('width-input');
    const lengthInput = document.getElementById('length-input');
    
    if (widthInput) {
      widthInput.addEventListener('input', validateDimensions);
      widthInput.addEventListener('change', validateDimensions);
    }
    
    if (lengthInput) {
      lengthInput.addEventListener('input', validateDimensions);
      lengthInput.addEventListener('change', validateDimensions);
    }
    
    // Calculate initial price on page load
    setTimeout(() => {
      validateDimensions();
      calculatePrice();
    }, 300);
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceCalculator);
  } else {
    initPriceCalculator();
  }
  
  // Export for potential external use
  window.priceCalculator = {
    calculate: calculatePrice,
    getCurrentWeight: () => currentWeight,
    getCalculationParams: getCalculationParams
  };
  
})();

// ========================================
// TEIL 4: Add to Cart für Blechzuschnitte
// ========================================
(function() {
  'use strict';

  // Show success toast
  function showSuccessToast() {
    const toast = document.createElement('div');
    toast.className = 'addtocart-success-toast';
    toast.innerHTML = `
      <div class="addtocart-success-icon">✓</div>
      <div class="addtocart-success-text">Produkt erfolgreich hinzugefügt!</div>
    `;

    document.body.appendChild(toast);

    // Auto remove after 2 seconds
    setTimeout(() => {
      toast.classList.add('fade-out');
      setTimeout(() => toast.remove(), 300);
    }, 2000);
  }

  // Open Shopify cart
  function openShopifyCart() {
    // Method 1: Cart drawer (Dawn theme and similar)
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      return;
    }

    // Method 2: Custom event
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Method 3: Check for cart notification
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
      return;
    }

    // Method 4: Fallback - redirect to cart page
    setTimeout(() => {
      window.location.href = '/cart';
    }, 500);
  }

  // Update cart count badge
  async function updateCartBadge() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const badges = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
      badges.forEach(badge => {
        badge.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart badge:', error);
    }
  }

  // Call /addtocart microservice to create a Shopify variant and get its ID
  async function callAddToCartMicroservice(params, config) {
    const endpoint = config.endpointAddToCart;

    if (!endpoint) {
      console.warn('Kein /addtocart Endpunkt konfiguriert – Schritt wird übersprungen');
      return null;
    }

    const payload = {
      produktart: config.produktart || '',
      type: params.type || 'custom',
      blechart: config.blechart || '',
      matID: config.materialId || 0,
      width: params.width || 0,
      length: params.length || 0,
      staerke: params.staerke || 0,
      amount: params.amount || 1,
      entgratung: params.entgratung || 0,
      express: params.express || 0,
      parentSku: config.productSku || '',
      parentProductId: String(config.productId || '')
    };

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let errMsg = 'Fehler beim Erstellen der Variante (Status ' + response.status + ')';
      try {
        const errData = await response.json();
        if (errData.message || errData.error) {
          errMsg = errData.message || errData.error;
        }
      } catch (_) { /* ignore */ }
      throw new Error(errMsg);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message || 'Fehler beim Erstellen der Variante');
    }

    return result.data || null;
  }

  // Build line item properties from params and config
  function buildLineItemProperties(params, config, addToCartData) {
    const properties = {};

    // Add visible properties (only if not empty)
    if (config.material) properties['Material'] = config.material;
    if (config.materialstaerke) properties['Materialstärke'] = config.materialstaerke;
    if (config.oberflaeche) properties['Oberfläche'] = config.oberflaeche;
    if (config.sichtseite) properties['Sichtseite'] = config.sichtseite;
    if (config.schutzfolie) properties['Schutzfolie'] = config.schutzfolie;
    if (config.lochung) properties['Lochung'] = config.lochung;
    if (config.lochgroesse) properties['Lochgröße & Abstand'] = config.lochgroesse;

    // Add dimensions
    if (params.width) properties['Breite'] = params.width + ' mm';
    if (params.length) properties['Länge'] = params.length + ' mm';

    // Add weight
    if (params.weight && params.weight > 0) {
      const formattedWeight = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 2
      }).format(params.weight);
      properties['Gewicht'] = formattedWeight + ' kg';
    }

    // Add custom-specific properties
    if (params.type === 'custom') {
      properties['Bestätigung'] = 'Eingabe in mm geprüft.';

      if (params.randauswahl) {
        properties['Randbehandlung'] = params.randauswahl;
      }

      if (params.express === 1) {
        properties['Expressbearbeitung'] = 'Ja';
      }
    }

    // Add hidden properties (prefix with underscore)
    if (config.materialId) properties['_materialId'] = config.materialId;
    if (config.anzeigenname) properties['_anzeigenname'] = config.anzeigenname;
    if (params.type) properties['_type'] = params.type;

    // Add price properties from priceCache for cart display
    const cache = window.priceCache || {};
    if (cache.price != null)      properties['_price']      = String(cache.price);
    if (cache.totalPrice != null)  properties['_totalPrice'] = String(cache.totalPrice);
    if (cache.old_price != null)   properties['_old_price']  = String(cache.old_price);

    // Add variant_id returned by /addtocart microservice as hidden property
    if (addToCartData && addToCartData.variant_id) {
      properties['_variant_id'] = String(addToCartData.variant_id);
    }

    // Extract configuration ID from SKU (last segment after splitting by ".")
    if (addToCartData && addToCartData.sku) {
      const skuParts = String(addToCartData.sku).split('.');
      if (skuParts.length > 0) {
        properties['_configuration_id'] = skuParts[skuParts.length - 1];
      }
    }

    return properties;
  }

  // Show inline error on cart button
  function showAddToCartError(message) {
    const errorEl = document.getElementById('price-error-message');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    }
    console.error('AddToCart Error:', message);
  }

  // Main add to cart handler
  async function handleAddToCart(event) {
    event.preventDefault();
    event.stopPropagation();

    // Check if config is available
    if (typeof window.priceConfigs === 'undefined') {
      showAddToCartError('Konfiguration nicht gefunden.');
      return;
    }

    const config = window.priceConfigs;

    // Get calculation parameters
    if (typeof window.priceCalculator === 'undefined' || !window.priceCalculator.getCalculationParams) {
      showAddToCartError('Preisrechner nicht initialisiert.');
      return;
    }

    const params = window.priceCalculator.getCalculationParams();

    // Validate mm-check toggle for custom products only
    if (params.type === 'custom') {
      const mmCheckToggle = document.getElementById('mm-check-toggle-' + config.sectionId);
      const mmCheckBox = document.getElementById('mm-check-box-' + config.sectionId);

      if (mmCheckToggle && !mmCheckToggle.checked) {
        if (mmCheckBox) {
          mmCheckBox.classList.add('highlight');
          mmCheckBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => { mmCheckBox.classList.remove('highlight'); }, 2000);
        }
        return;
      }
    }

    // Validate that a price has been calculated
    const cache = window.priceCache || {};
    if (cache.price == null || cache.totalPrice == null) {
      showAddToCartError('Bitte warten Sie, bis der Preis berechnet wurde.');
      return;
    }

    // Get variant ID from the form hidden input
    const form = event.target;
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
      showAddToCartError('Keine Variante ausgewählt.');
      return;
    }
    const variantId = parseInt(variantInput.value, 10);
    const quantity = params.amount || 1;

    // Disable button while adding
    const cartButton = form.querySelector('.btn-cart');
    const originalButtonText = cartButton ? cartButton.textContent : '';
    if (cartButton) {
      cartButton.disabled = true;
      cartButton.textContent = 'Wird hinzugefügt...';
    }

    // Hide previous errors
    const errorEl = document.getElementById('price-error-message');
    if (errorEl) errorEl.style.display = 'none';

    try {
      // Step 1: Call /addtocart microservice to create variant and get its ID
      let addToCartData = null;
      if (config.endpointAddToCart) {
        if (cartButton) cartButton.textContent = 'Produkt wird vorbereitet...';;
        addToCartData = await callAddToCartMicroservice(params, config);
      }

      // Step 2: Build line item properties (including _variant_id from microservice response)
      const lineItemProperties = buildLineItemProperties(params, config, addToCartData);

      // Step 3: Add to Shopify cart
      if (cartButton) cartButton.textContent = 'Wird hinzugefügt...';

      const requestBody = {
        items: [{
          id: variantId,
          quantity: quantity,
          properties: lineItemProperties
        }]
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        let errorDetails = '';
        try {
          const errData = await response.json();
          errorDetails = errData.description || errData.message || '';
        } catch (_) { /* ignore */ }
        throw new Error(errorDetails || 'Fehler beim Hinzufügen zum Warenkorb (Status ' + response.status + ')');
      }

      // Success
      clearDimensionsFromSession();
      showSuccessToast();
      await updateCartBadge();

      setTimeout(() => {
        openShopifyCart();
      }, 300);

    } catch (error) {
      console.error('AddToCart error:', error);
      showAddToCartError(error.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
    } finally {
      // Re-enable button
      if (cartButton) {
        cartButton.disabled = false;
        cartButton.textContent = originalButtonText;
      }
    }
  }

  // Initialize add to cart functionality
  function initAddToCart() {
    const form = document.querySelector('[data-type="add-to-cart-form"]');
    if (!form) {
      console.warn('Add to cart form not found');
      return;
    }

    form.addEventListener('submit', handleAddToCart);
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddToCart);
  } else {
    initAddToCart();
  }

})();

// ========================================
// TEIL 5: Checkout Interception – Cart-to-Draft-Order
// ========================================
// Uses Event Delegation: a single click handler on document catches ALL
// checkout buttons – even those added later via AJAX re-renders.
// No MutationObserver, no data-attribute guards, no handler stacking.
(function() {
  'use strict';

  // CSS selector that matches every checkout button in the store
  const CHECKOUT_SELECTOR = [
    '#checkout',                                        // main cart page
    '#CartDrawer-Checkout',                             // cart drawer
    'button[name="checkout"]',                           // any generic checkout btn
    'input[name="checkout"]'                             // fallback
  ].join(',');

  // Guard against double-clicks while a request is in flight
  let checkoutInFlight = false;

  // Handle checkout button click
  async function handleCheckout(btn) {
    if (checkoutInFlight) return;
    checkoutInFlight = true;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Bitte warten...';

    try {
      // 1. Fetch the current cart contents
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      });

      if (!cartResponse.ok) {
        throw new Error('Warenkorb konnte nicht geladen werden.');
      }

      const cart = await cartResponse.json();

      if (!cart.items || cart.items.length === 0) {
        throw new Error('Ihr Warenkorb ist leer.');
      }

      // 2. Build the payload for /addtocart2
      const items = cart.items.map(item => ({
        variant_id: item.variant_id,
        product_id: item.product_id,
        quantity: item.quantity,
        sku: item.sku,
        title: item.title,
        price: item.price,
        properties: item.properties || {}
      }));

      // Determine the endpoint
      const endpoint =
        (window.priceConfigs && window.priceConfigs.endpointAddToCart2) ||
        btn.dataset.endpointAddtocart2 ||
        window.checkoutEndpoint ||
        '';

      if (!endpoint) {
        throw new Error('Checkout-Endpunkt ist nicht konfiguriert.');
      }

      // 3. POST to /addtocart2
      const checkoutResponse = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      if (!checkoutResponse.ok) {
        let errMsg = 'Checkout fehlgeschlagen (Status ' + checkoutResponse.status + ')';
        try {
          const errData = await checkoutResponse.json();
          if (errData.message || errData.error) {
            errMsg = errData.message || errData.error;
          }
        } catch (_) { /* ignore */ }
        throw new Error(errMsg);
      }

      const result = await checkoutResponse.json();

      // 4. Backup cart & redirect to the invoice_url
      const invoiceUrl =
        (result.data && result.data.invoice_url) ||
        result.invoice_url ||
        null;

      if (!invoiceUrl) {
        throw new Error('Keine Checkout-URL in der Antwort erhalten.');
      }

      // window.backupCartAndRedirect is defined in TEIL 6 (loaded in the same file)
      if (typeof window.backupCartAndRedirect === 'function') {
        await window.backupCartAndRedirect(cart, invoiceUrl);
      } else {
        // Fallback: redirect without backup
        window.location.href = invoiceUrl;
      }
      return; // navigating away

    } catch (error) {
      console.error('Checkout interception error:', error);
      alert(error.message || 'Ein Fehler ist beim Checkout aufgetreten. Bitte versuchen Sie es erneut.');
      btn.disabled = false;
      btn.textContent = originalText;
      checkoutInFlight = false;
    }
  }

  // ---- Delegated click handler (catches all current AND future buttons) ----
  document.addEventListener('click', function(e) {
    const btn = e.target.closest(CHECKOUT_SELECTOR);
    if (!btn) return; // click was not on a checkout button

    e.preventDefault();
    e.stopPropagation();
    handleCheckout(btn);
  }, true); // useCapture = true → runs before any other handler

  // ---- Delegated submit handler (safety net for form submissions) ----
  document.addEventListener('submit', function(e) {
    const submitter = e.submitter;
    if (submitter && submitter.matches(CHECKOUT_SELECTOR)) {
      e.preventDefault();
      e.stopPropagation();
      handleCheckout(submitter);
    }
  }, true);

})();

// ========================================
// TEIL 6: Warenkorb-Backup & Restore (Draft Order Workflow)
// ========================================
(function () {
  'use strict';

  const BACKUP_KEY = 'draft_cart_backup';

  // ------------------------------------------------------------------
  // 1. backupCartAndRedirect(cartJson, invoiceUrl)
  //    Called right before we hand the user off to the Draft Order URL.
  //    a) Strips the cart down to the minimal re-import data.
  //    b) Persists it in sessionStorage.
  //    c) Clears the Shopify cart via /cart/clear.js.
  //    d) Redirects to invoiceUrl (even if clearing fails).
  // ------------------------------------------------------------------
  async function backupCartAndRedirect(cartJson, invoiceUrl) {
    // a) Extract only the fields needed to re-add items later
    const itemsToBackup = (cartJson.items || []).map(function (item) {
      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || {}
      };
    });

    // b) Persist to sessionStorage
    try {
      sessionStorage.setItem(BACKUP_KEY, JSON.stringify(itemsToBackup));
    } catch (e) {
      console.warn('[CartBackup] sessionStorage write failed:', e);
    }

    // c) Clear the Shopify cart
    try {
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      });
      if (!clearResponse.ok) {
        console.warn('[CartBackup] /cart/clear.js returned', clearResponse.status, '– redirecting anyway');
      }
    } catch (e) {
      console.warn('[CartBackup] Failed to clear cart:', e, '– redirecting anyway');
    }

    // d) Redirect (always, even if clearing failed)
    window.location.href = invoiceUrl;
  }

  // Expose globally so TEIL 5's handleCheckout can call it
  window.backupCartAndRedirect = backupCartAndRedirect;

  // ------------------------------------------------------------------
  // 2. Restore listener – runs on every page load.
  //    • If no backup exists        → do nothing.
  //    • If cart is not empty       → customer added new items;
  //                                   discard the backup.
  //    • If cart is empty           → restore the backed-up items via
  //                                   /cart/add.js and reload the page.
  // ------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', async function restoreCartBackup() {
    // 1. Check whether a backup exists
    const backupJson = sessionStorage.getItem(BACKUP_KEY);
    if (!backupJson) return;

    try {
      // 2. Fetch the current cart
      const cartResponse = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (!cartResponse.ok) {
        console.warn('[CartRestore] Could not fetch /cart.js – aborting restore');
        return;
      }
      const currentCart = await cartResponse.json();

      // 3. Cart already has items → customer added something new; discard backup
      if (currentCart.item_count > 0) {
        sessionStorage.removeItem(BACKUP_KEY);
        console.log('[CartRestore] Cart not empty – backup discarded.');
        return;
      }

      // 4. Cart is empty → restore
      let itemsToRestore;
      try {
        itemsToRestore = JSON.parse(backupJson);
      } catch (parseErr) {
        console.error('[CartRestore] Could not parse backup JSON:', parseErr);
        sessionStorage.removeItem(BACKUP_KEY);
        return;
      }

      if (!Array.isArray(itemsToRestore) || itemsToRestore.length === 0) {
        sessionStorage.removeItem(BACKUP_KEY);
        return;
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: itemsToRestore })
      });

      if (!addResponse.ok) {
        let msg = '/cart/add.js returned ' + addResponse.status;
        try {
          const errData = await addResponse.json();
          if (errData.message) msg = errData.message;
        } catch (_) { /* ignore */ }
        console.error('[CartRestore] Restore failed:', msg);
        return; // keep backup so the next page load can retry
      }

      // Success – clean up and reload so the theme reflects the restored cart
      sessionStorage.removeItem(BACKUP_KEY);
      window.location.reload();

    } catch (e) {
      console.error('[CartRestore] Unexpected error during restore:', e);
    }
  });

})();
